import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { crmApi, type CustomerDashboard } from '../../api/crm';

const NAV = [
  { to: '/customers/directory', label: 'Directory' },
  { to: '/customers/360', label: 'Customer 360' },
  { to: '/customers/segments', label: 'Segmentation' },
  { to: '/customers/loyalty', label: 'Loyalty' },
  { to: '/customers/wallet', label: 'Wallet' },
  { to: '/customers/support', label: 'Support' },
  { to: '/customers/analytics', label: 'Analytics' },
];

export function CustomerHubPage() {
  const [dashboard, setDashboard] = useState<CustomerDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void crmApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total customers', value: dashboard.total_customers },
        { label: 'Active', value: dashboard.active_customers },
        { label: 'New this month', value: dashboard.new_this_month },
        { label: 'Open cases', value: dashboard.open_cases },
        { label: 'Loyalty points', value: dashboard.total_loyalty_points },
        { label: 'Avg health', value: `${dashboard.avg_health_score.toFixed(0)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Customer 360 & CRM</h1>
      <p className="mt-1 text-sm text-slate-600">Unified profiles, loyalty, wallet, segmentation and AI intelligence.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
